module.exports = __webpack_public_path__ + "static/screenshot1-33013e51e76c9a578ce6fbbc6c4ec53d.png";